'use strict';

angular.module('Filters', []);
angular.module('Services', []).config(['$httpProvider', function ($httpProvider) {
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
}]);

angular.module('Directives', []);
angular.module('Authentication', []);
angular.module('Const', []);
angular.module('app', [
    'ng.deviceDetector',
    'ngFileUpload',
    'ngRoute',
    'ngCookies',
    'ngSanitize',
    'Services',
    'Filters',
    'Directives',
    'Authentication',
    'Const',
    'ui.bootstrap',
    'ui.mask',
    'ui.select',
    'toggle-switch',
    'toastr',
    'angularSpinner',
    'pascalprecht.translate',
    'ngMessages',
    'uiCropper',
    'LocalStorageModule',
    'btford.socket-io',
    'angular-csv-parser',
    'angular-jwt',
    'ngDraggable'
]).controller('BaseController', function (
    $scope,
    $rootScope,
    $timeout,
    $route,
    Request,
    AuthenticationService,
    $cookies,
    Profile,
    ClientService,
    toastr,
    $location,
    $window,
    $interval,
    DownloadReportsSocketService,
    NotificationsService,
    RouteParamsService,
    $http,
    $q,
    ErrorReportingService
) {
    $rootScope.showedMenu = false;
    $rootScope.searchFocus = false;
    $rootScope.menuCollapsed = false;
    $rootScope.isAgreedTerms = true;
    $rootScope.currentRouteParams = {};
    $rootScope.loggingIn = true;
    $rootScope.collapseMenu = collapseMenu;
    $rootScope.setSearchFocus = setSearchFocus;
    $rootScope.toggleMenu = toggleMenu;
    $rootScope.logOut = logOut;
    $rootScope.resetForm = resetForm;

    $scope.defaultResellers = [{ name: 'Select All', id: null }];
    $scope.resellerView = angular.copy($scope.defaultResellers[0]);
    $scope.keyword = $location.search().keyword;
    $scope.runSearch = runSearch;
    $scope.viewAsReseller = viewAsReseller;
    $scope.searchForReseller = searchForReseller;
    $scope.headers = headers;

    init();

    function init() {
        getCompanyConfig();
        connectToSockets();
        twoFactorAuthentication();
        listenForUserActivity();
        initRenewTokenInterVal();
        initLoginData();
    }

    function getCompanyConfig() {
        let host = $window.location.host.split('.')[1];
        $rootScope.Company = {};
        switch (host) {
            case 'srktransport':
                $scope.Company = {
                    logo: '/images/srktransport/srk-logo.png',
                    title: 'SRK',
                    name: 'srk',
                    link: 'http://srktransport.com.au/',
                    pageTitle: 'SRK Transport | Powered by BBA'
                }
                break;
            case 'alfalogistics':
                $rootScope.Company = {
                    logo: '/images/alfa-logo.png',
                    title: 'ALFA',
                    name: 'alfa',
                    link: 'http://alfalogistics.com.au/',
                    pageTitle: 'Alfa Logistics Service | Powered by BBA'
                };
                break;
            default:
                $rootScope.Company = {
                    logo: '/images/adminlogo.png',
                    title: 'BBA',
                    name: 'bba',
                    link: 'http://bbamastro.com/',
                    pageTitle: 'BBA Mastro Service'
                };
                break;
        }
    }

    function initRenewTokenInterVal() {
        const tokenData = angular.fromJson(localStorage.getItem('c_td'));
        if (!angular.getObjVal(tokenData, 'data.expires_in')) { return; }

        const intervalDuration = Number(tokenData.data.expires_in) * .3 * 1000; // 3% of the expiration time
        $interval(() => { updateToken(); }, intervalDuration);
    }

    function updateToken() {
        AuthenticationService.refreshToken(success => { }, error => { });
    }

    function initLoginData() {
        const tokenData = angular.fromJson(localStorage.getItem('c_td'));
        if (!tokenData) {
            $rootScope.logOut();
            return;
        }

        $http.defaults.headers.common.Authorization = 'Bearer ' + tokenData['data']['access_token'];
        $rootScope.isAgreedTerms = tokenData.data.adminTermsAndConditionAccepted;
        $rootScope.currentRouteParams = RouteParamsService.get();
        $cookies.put('isAgreedTerm', $rootScope.isAgreedTerms, getCookieExpiration(tokenData));

        getLoggedInUser();
        preloadData();

        DownloadReportsSocketService.disconnect();
        DownloadReportsSocketService.init();
    }

    function getCookieExpiration(tokenData) {
        return {
            expires: new Date((new Date()).getTime() + Math.min(40 * 60 * 1000, (tokenData['data']['expires_in'] + 10) * 1000)),
            path: '/',
            secure: false
        };
    }

    function getLoggedInUser() {
        if ($rootScope.GlobalProfile) {
            $scope.hasInitialized = true;
            return;
        }

        Profile.getUser(function (data) {
            $rootScope.loggingIn = false;
            $rootScope.GlobalProfile = data;
            setRouteGuard($rootScope.GlobalProfile);
            $scope.initializing = false;
            $scope.hasInitialized = true;
            if (+data.company.id === 1) {
                const reseller = { name: data.company.name, id: 1 };
                $scope.defaultResellers.push(reseller);
                $scope.resellerView = angular.copy(reseller);
                viewAsReseller(reseller);
            }

            const roles = $rootScope.GlobalProfile.permissionGroup.roles;
            const marketingRole = roles.find(r => r.code === 'ROLE_MARKETING_USER' || r.code === 'ROLE_MARKETING_ADMIN');
            if (marketingRole) {
                $location.path('/affiliates-sales');
            }
            if (!$rootScope.isAgreedTerms) {
                $location.path('/terms-and-conditions');
            }
        });
    }

    function preloadData() {
        loadCompanies();
        loadOffices();
    }

    function loadCompanies() {
        const defer = $q.defer();
        ClientService.Client.getAvailableCompany(data => {
            defer.resolve(data);
        }, error => {
            defer.reject(error);
        });
        return defer.promise;
    }

    function loadOffices() {
        const defer = $q.defer();
        ClientService.Client.getAvailableOffice(data => {
            defer.resolve(data);
        }, error => {
            defer.reject(error);
        });
        return defer.promise;
    }

    function runSearch(keyword) {
        redirectTo({
            url: 'search',
            queryParams: { keyword: keyword || '' }
        })
    }

    function viewAsReseller(client) {
        $route.reload();
        Request.setRequestAsClient(client);
    }

    function searchForReseller(select) {
        if (!select.open) { return false; }

        $scope.resellers = [];
        $scope.searchingForReseller = true;
        ClientService.Reseller.getAll(data => {
            $scope.resellers = [...$scope.defaultResellers, ...data.content];
            $scope.searchingForReseller = false;
        }, err => {
            toastr.error('Unable to search for resellers', err.message);
            $scope.searchingForReseller = false;
        }, {
            name: select.search,
            sort: 'id, desc'
        })
    }

    function redirectTo(pathOptions) {
        $location.path(pathOptions.url).search(pathOptions.queryParams || {});
    }

    function setRouteGuard(user) {
        setRestrictions(user);

        if (angular.getObjVal($route, 'current.$$route.params.restricted')) {
            redirectTo({
                url: '/'
            });
        }

        function setRestrictions(user) {
            const adminPermission = user.permissionGroup.roles.find(group => {
                return group.code === 'ROLE_COMPANY_ADMIN' || group.code === 'ROLE_ADMIN' || group.code === 'ROLE_MARKETING_ADMIN' || group.code === 'ROLE_ADMIN_PORTAL_ACCESS' || group.code === 'ROLE_MARKETING_USER';
            });
            const fleetPermission = user.permissionGroup.roles.find(group => group.code === 'ROLE_FLEET_AND_ROUTE');
            angular.forEach($route.routes, (route, key) => {
                //set primary restrictions
                route.params ? route.params.restricted = !adminPermission : route.params = {
                    restricted: !adminPermission
                };

                //modify specific restrictions
                if (route.params.restricted && fleetPermission) {
                    if (key.indexOf('/shipments') > -1 ||
                        key.indexOf('/clients') > -1 ||
                        key.indexOf('/carriers') > -1 ||
                        key.indexOf('/margins') > -1 ||
                        key.indexOf('/areas') > -1 ||
                        key.indexOf('/jobs') > -1 ||
                        key.indexOf('/fleets') > -1 ||
                        key === '/')
                        route.params.restricted = false;
                }
                else if (key.indexOf('/networking') > -1) //|| key.indexOf('/administration') > -1)
                    route.params.restricted = $rootScope.GlobalProfile.company.id !== 1;

                else if (key.indexOf('/terms-and-conditions') > -1) {
                    route.params.restricted = false;
                }
            });
        }
    }

    function listenForUserActivity() {
        document.body.addEventListener('mousemove', event => {
            localStorage.setItem('counter', angular.toJson(0));
        });
        document.body.addEventListener('keypress', event => {
            localStorage.setItem('counter', angular.toJson(0));
        });
        $interval(() => {
            $scope.counter = angular.fromJson(localStorage.getItem('counter'));
            $scope.counter++;
            localStorage.setItem('counter', angular.toJson($scope.counter));
        }, 1000);
        let unbind = $scope.$watch('counter', (newVal, oldVal) => {
            const counter = angular.fromJson(localStorage.getItem('counter'));
            if (counter > 3600) {
                $scope.secondsPass = 0;
                $rootScope.logOut();
                unbind();
            }
        });
    }

    function connectToSockets() {
        $rootScope.$watch('GlobalProfile', (value) => {
            if (value) {
                downloadReportsNotifications();
            }
        });
    }

    function twoFactorAuthentication() {
        var twoFactorAuthentication = $cookies.get('twoFactorVerifitacion');
        if (twoFactorAuthentication) {
            $rootScope.logOut(null, 'TWO FACTOR', 'FROM TWO FACTOR LOGOUT');
            unbind();
        }
    }

    function downloadReportsNotifications() {
        DownloadReportsSocketService.init();

        getNotifications();
        $scope.$on('notif-updated', (event, data) => {
            getNotifications();
        });
    }

    function getNotifications() {
        $scope.notifCount = NotificationsService.getNotifications().length;
        $scope.notifData = NotificationsService.getNotifications();
    }

    function headers() {
        const params = $route.current.$$route.params || {};
        RouteParamsService.set(params);
        const paramsHeader = RouteParamsService.get();
        return !paramsHeader.customHeader
    }

    function collapseMenu() {
        $rootScope.menuCollapsed = !$rootScope.menuCollapsed;
    }

    function setSearchFocus(fl) {
        $rootScope.searchFocus = !fl;
    }

    function toggleMenu() {
        $rootScope.showedMenu = !$rootScope.showedMenu;
    }

    function logOut(lastVisit = null, trigger = null, message = null) {
        if (trigger && angular.getObjVal($rootScope.GlobalProfile, 'id')) {
            const payload = {
                "userId": $rootScope.GlobalProfile.id,
                "userEmail": $rootScope.GlobalProfile.email,
                "trigger": `${message}--admin--${trigger}`,
                "triggerDate": moment().format('YYYY-MM-DDTHH:mm:ss.SSSZZ')
            };

            ErrorReportingService.sendError(
                () => { performLogout(lastVisit); }, 
                () => { performLogout(lastVisit); }, 
                payload
            );
            return;
        }

        performLogout(lastVisit);
    }

    function performLogout(lastVisit) {
        AuthenticationService.ClearCredentials();
        NotificationsService.clearNotifications();
        DownloadReportsSocketService.disconnect();
        $window.location = loginPageURL + (lastVisit ? `?page=${lastVisit}` : '');
    }

    function resetForm() { model = {}; }
})
    .controller('ExitController', function ($rootScope) {
        $rootScope.logOut();
    }).run(['$rootScope', '$uibModalStack', '$route', 'RouteParamsService', function ($rootScope, $uibModalStack, $route, RouteParamsService) {
        $rootScope.$on('$locationChangeStart', handleLocationChange);

        function handleLocationChange() {
            $uibModalStack.dismissAll();
        }
    }])
    .config(['$translateProvider', '$httpProvider', function ($translateProvider, $httpProvider) {
        //$httpProvider.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
        $translateProvider.useStaticFilesLoader({
            prefix: '/languages/',
            suffix: '.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useCookieStorage();
        $translateProvider.useSanitizeValueStrategy('sanitize');
    }])
    .config(function (toastrConfig) {
        angular.extend(toastrConfig, {
            timeOut: 30000
        });
    }).factory('RouteParamsService', function () {
        let currentParams = {};

        return {
            get: () => currentParams,
            set: (params) => { currentParams = params; }
        };
    });




// WEBPACK FOOTER //
// ./js/app.js